import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { Certifivate_Delivery_Interface } from 'src/app/Interface/Certifivate_Delivery_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CertificateService } from 'src/app/Service/Certificate/Certificate.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CertifivateDeliveryList',
  templateUrl: './CertifivateDeliveryList.component.html',
  styleUrls: ['./CertifivateDeliveryList.component.scss']
})
export class CertifivateDeliveryListComponent implements OnInit {

  Token:String=""
  page:number=0;
  Procssing:boolean=false
  Data_List_Delivery:Array<Certifivate_Delivery_Interface>=[]
  Data_List_Delivery_seletect:Certifivate_Delivery_Interface
  modalRef_Pay: any;

  constructor(
    private modalService: BsModalService,
    private Certificate_Service:CertificateService,
    private Nav_Service:NavService,
    private Alerify:AlertifyService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token,14).subscribe(
      data=>{
        this.ReadData_Certificate()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
    
  }

  ReadData_Certificate(){
    this.Procssing=true
      this.Certificate_Service.GetDelivery(this.Token).subscribe(
        data=>{
          this.Procssing=false
          this.Data_List_Delivery=data
        },error=>{
          localStorage.clear()
          location.reload();

        }
      )

  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_List_Delivery_seletect=Record
    this.modalRef_Pay = this.modalService.show(template);
  }

  PayedRecord(item:Certifivate_Delivery_Interface){
    this.Procssing=true
    this.modalRef_Pay.hide()
    this.Certificate_Service.DeliveryPayed(item.id,this.Token).subscribe(
      data=>{

        this.Alerify.SuccessMessage("Paid successfully")
        this.ReadData_Certificate()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


}
